import React from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'

import { Skeleton } from 'primereact/skeleton'

import { useTenantById } from '../../data/tenants'

type TenantInfoProps = {
  tenantId?: string
}

const TenantInfo: React.FC<TenantInfoProps> = ({ tenantId }) => {
  const { t } = useTranslation()

  const { data, isLoading, error } = useTenantById(tenantId as string)

  if (!tenantId) return <div>{t('tenant.tenantInfo.message')}</div>
  if (error) return <Navigate to="/set-tenant" />
  if (isLoading) return <Skeleton className="mb-2" />

  return <div>{data?.name}</div>
}

export default TenantInfo
